/**
 * Manages the more modern bootstrap modal.
 * Use this instead of PopupManager.
 */

var VRC = VRC || {};


VRC.ModalManager = (function () {
	var $modal;
	var modalCount;


	var init = function () {
		modalCount = 0;
		keepTrackOnOpenModals();
	};

	var keepTrackOnOpenModals = function () {
		$('.modal').on('hidden.bs.modal', function (event) {
			$(this).removeClass('modal-stacked');
			modalCount = modalCount - 1;
		});

		$('.modal').on('shown.bs.modal', function (event) {			
			if (!$(this).hasClass('modal-stacked')) {
			modalCount = modalCount +1;
			$(this).addClass('modal-stacked');			
			$(this).css('z-index', 1040 + (15 * modalCount));
			$('.modal-backdrop').not('.modal-stacked').css('z-index', 1039 + (15 * modalCount));
			$('.modal-backdrop').not('modal-stacked').addClass('modal-stacked');
			}
		});
	};

	var show = function (template, ctx) {

		ctx = ctx || {};
		var handlebarTemplate = WELL.Handlebars.VRC[template];

		$modal = $('#modal');
		$modal.html(handlebarTemplate(ctx));

		$modal.filter('.modal').modal();
	};
	var hide = function () {
		$modal = $('#modal');
		$modal.modal('hide');
	};

	return {
		init: init,
		show: show,
		hide: hide,
		modalCount: modalCount
	}
})();

$(document).ready(function () {
	VRC.ModalManager.init();

});


